export const environment = {
  production: true,
  host: 'https://api.staqable.com',
  port: '443',
  apiBaseUrl: 'https://api.staqable.com',
  wsHost: 'wss://api.staqable.com',
  wsPort: '443',
  // CloudFront in front of the media bucket. The API already returns CDN URLs
  // (MediaCdnMiddleware rewrites them server-side); this is the client's own fallback for
  // URLs that reach a template without having come through the API.
  // The customer-facing storefront. Backoffice sign-in refuses `customer` accounts and
  // points them here instead — they belong to this site, not to the backoffice.
  storefrontUrl: 'https://krutapara.com',
  // Origin site-chat context links open on, instead of the site bot's `domain` (dev only).
  chatContextSiteOrigin: '',
  mediaCdnUrl: 'https://cdn.staqable.com',
  vapidPublicKey:
    'BC4S8NXZHjMbjOKz4f5LwWJnIkYyDAc530UaiWz-1CqnHj0oPzGa7DZs9Sjuv8QoNyePAiyE25P5jfTwkyk-Cog',
};
